import request from 'services/request';

export async function POGMassiveUpload({ cancelToken, data }) {
  let uri = `/Catalogs/Api/v1/Pog/MassLoadExcel`;
  return request(uri, {
    method: 'POST',
    cancelToken,
    data,
  });
}
